"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Close = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Close = function Close(_a) {
  var id = _a.id;
  var clipPathId = id ? "Close__clip0__".concat(id) : 'Close__clip0';
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("g", {
    clipPath: "url(#".concat(clipPathId, ")")
  }, react_1.default.createElement("path", {
    fill: "currentColor",
    d: "M23.704 20.883a1 1 0 010 1.42l-1.4 1.401a1 1 0 01-1.42 0L12 14.821l-8.883 8.883a1 1 0 01-1.42 0l-1.401-1.4a1 1 0 010-1.42L9.179 12 .296 3.117a1 1 0 010-1.42l1.4-1.401a1 1 0 011.42 0L12 9.179 20.883.296a1 1 0 011.42 0l1.401 1.4a1 1 0 010 1.42L14.821 12l8.883 8.883z"
  })), react_1.default.createElement("defs", null, react_1.default.createElement("clipPath", {
    id: clipPathId
  }, react_1.default.createElement("path", {
    fill: "#fff",
    d: "M0 0H24V24H0z"
  }))));
};

exports.Close = Close;